//systems maps
export const OTP_ModeMap = {
    EMAIL: 0,
    PHONE: 1,
    DUO: 2
}
export const System_DeviceOrientationMap = {
    PORTRAIT: 0,
    LANDSCAPE: 1
}

//page maps
export const Login_PageModeMap = {
    LOGIN: 0,
    MEMBERSHIP_SELECTION: 1,
    PASSWORD_LOGIN: 2,
    PASSWORD_RESET: 3,
    EMAIL_RETRIEVE: 4
};
export const Miscellaneous_PageMap = {
    ABOUT_APP: 0,
    TERMS_AND_CONDITIONS: 1,
    PRIVACY_POLICY: 2,
    CONTACT_US: 3,
    USER_MANUALS: 4
};
export const ViewEventGallery_PageMap = {
    CATEGORY_SELECTION: 0,
    YEAR_SELECTION: 1,
    EVENT_SELECTION: 2,
    GALLERY: 3,
    UPLOAD_PHOTOS: 4
};
export const ManageEventAttachment_PageMap = {
    CATEGORY_SELECTION: 0,
    EVENT_SELECTION: 1,
    ATTACHMENTS: 2,
    UPLOAD_ATTACHMENTS: 3
};
export const ViewEventGallery_GalleryViewMode = {
    UNO: 1,
    DUO: 2,
    TRIO: 3,
    QUAD: 4
};
export const ViewEventGallery_UserMode = {
    MEMBER: 0,
    COMMITTEE: 1
};
export const ViewDocuments_PageMap = {
    CATEGORY_SELECTION: 0,
    DOCUMENT_SELECTION: 1,
    UPLOAD_DOCUMENTS: 2,
    DOCUMENT_SETUP: 3
};
export const ViewDocuments_UserMode = {
    MEMBER: 0,
    COMMITTEE: 1
};
export const App_ViewModeMap  = {
    MEMBER: 0,
    COMMITTEE: 1
};
export const Events_PageMap = {
    // DISCOVER: 0,
    UPCOMING: 0,
    PAST: 1,
    DETAILS: 2,
    JOIN: 3,
    PAYMENT: 4,
    INVOICE_COMPLETE: 5
};
export const Events_PublicBeneficiaryMode = {
    ID: 0,
    SALUTATION: 1,
    FULL_NAME: 2,
    EMAIL: 3,
    PHONE: 4,
    DESIGNATION: 5,
    RPM_NO:6
};
export const Events_SortModeMap = {
    ASCENDING: 0,
    DESCENDING: 1
};
export const MyEvents_PageMap = {
    UPCOMING: 0,
    PAST: 1,
    DETAILS: 2,
    TICKETS: 3,
    SNAP: 4
};
export const MyEvents_ShareModeMap = {
    SHARE: 0,
    DOWNLOAD: 1
};
export const MyEvents_SortModeMap = {
    ASCENDING: 0,
    DESCENDING: 1
};
export const EventRegistrations_PageMap = {
    // PENDING: 0,
    // SUCCESS: 1,
    // FAILED: 2
    MAIN: 0,
    REGISTRATION_INFO: 1
};
export const EventRegistrations_SortModeMap = {
    ASCENDING: 0,
    DESCENDING: 1
};
export const ViewMeetings_PageMap = {
    UPCOMING: 0,
    PAST: 1,
    DECLINED: 2,
    EDIT: 3
};
// export const MembershipRenewal_PageMap = {
//     MEMBERSHIP: 0,
//     RENEWAL: 1
// }; ---deprecated
export const MembersList_ViewModeMap = {
    CORPORATE: 0,
    INDIVIDUAL: 1,
    OTHERS: 2
};
export const ViewPolls_PageMap = {
    NEW_POLLS: 0,
    VOTED_POLLS: 1,
    MY_POLLS: 2,
    CREATE_POLL: 3,
    EDIT_POLL: 4,
    VOTE_DETAILS: 5
};
export const ViewPolls_filterMode = {
    ALL: 0,
    SCHEDULED: 1,
    ONGOING: 2,
    ENDED: 3
};
export const ViewPolls_createEditPollMode = {
    CREATE: 0,
    EDIT: 1
};
export const ManageMembership_PageMap = {
    MEMBERSHIP_INFO: 0,
    MANAGE_ACCOUNTS: 1,
    // MEMBERSHIP_RENEWAL: 2,
    // RENEWAL_CHECKOUT: 3, ---deprecated
    PROFILE_INFO: 4,
    CREATE_USER: 5
}
export const ManageNotifications_SortMap = {
    ASCENDING: 0,
    DESCENDING: 1
};
export const ManageNotifications_PageMap = {
    MAIN: 0,
    CREATE_EDIT_MENU: 1,
    
};
export const ManageNotifications_ModeMap = {
    CREATE: 0,
    EDIT: 1
};
export const ManageNotifications_NotificationViewMode = {
    SCHEDULED: 0,
    CURRENT: 1,
    PAST: 2
}
//obj keymaps
export const Member_StatusMap = {
    INACTIVE: 0,
    ACTIVE: 1
};
export const Member_TypeMap = {
    UNSTATED: 0,
    CORPORATE: 1,
    INDIVIDUAL: 2,
    ASSOCIATE: 3,
    AFFILIATE_CORPORATE: 4,
    AFFILIATE_INDIVIDUAL: 5
};
export const MemberUser_TypeMap = {
    // PRIMARY: 0,
    // SECONDARY: 1
    APPOINTED: '0',
    ALTERNATE: '1',
    OTHERS: '2'
};
export const MemberUser_CommitteeTypeMap = {
    NONCOMMITTEE: 0,
    COMMITTEE: 1,
    SECRETARIATE: 2,
    ADVISOR: 3
};
export const MemberUser_StatusMap = {
    INACTIVE: 0,
    ACTIVE: 1
};
export const MemberUser_RaceMap = {
    MALAY: 0,
    CHINESE: 1,
    INDIAN: 2,
    INDIGENOUS_PEOPLES: 3,
    OTHERS:4
};
export const MemberUser_GenderMap = {
    MALE: 1,
    FEMALE: 0
};
export const MemberUser_MaritalStatusMap = {
    SINGLE: 0,
    MARRIED: 1,
    DIVORCED: 2,
    WIDOWED: 3,
    SEPARATED: 4
};
export const MemberUser_AcademicQualificationMap = {
    NONE: 0,
    CERTIFICATE: 1,
    DIPLOMA: 2,
    ADVANCED_DIPLOMA: 3,
    BACHELOR: 4,
    MASTERS: 5,
    DOCTORAL: 6
};
export const MemberUser_SalutationMap = {
    'Mr': 0,
    'Mrs': 1,
    'Ms': 2,
    'Dato': 3,
    'Tan Sri': 4,
    'Puan Sri': 5,
    'Datuk Seri': 6,
    'Datin Seri': 7,
    'Datuk': 8,
    'Datin': 9,
    'Dr': 10,
    'Miss': 11,
    'Others': 12
};
export const EventCategory_CategoryTypeMap = {
    EVENT: 0,
    MEETING: 1
};
export const EventRegistration_HRDClaimStatusMap = {
    NO_HRD_CLAIM: 0,
    HRD_CLAIM: 1
};
export const EventRegistration_HRDGrantStatusMap = {
    PENDING: 0,
    HRD_GRANT: 1,
    HRD_PAID: 2
};
export const Event_CategoryMap = {
    EVENT: 0,
    MEETING: 1
};
export const MeetingInvitation_InvitationStatusMap = {
    ALL: -1,
    PENDING: 0,
    ACCEPTED: 1,
    DECLINED: 2
};
export const EventItem_TypeMap = {
    GALLERY: 0,
    ATTACHMENT: 1
};
export const Payment_StatusMap = {
    PENDING: 0,
    PAID: 1,
    UNPAID: 2,
    HRDC_PAID: 3
};
export const MemberFee_TypeMap = {
    ENTRANCE: 0,
    SUBSCRIPTION: 1
};
export const OtherUserInfo_StatusMap = {
    SUSPEND: 0,
    ACTIVE: 1,
    EXPIRED: -1
};
export const EventRegistration_StatusFilterMap = {
    ALL: 0,
    PENDING: 1,
    SUCCESSFUL: 2,
    FAILED: 3
};
export const EventRegistration_DietaryOptionsMap = {
    'No Restrictions': 0,
    'Vegetarian': 1,
    'Vegan': 2,
    'Pescatarian': 3,
    'Halal': 4,
    'Kosher': 5,
    'Jain': 6
};